import React, { HTMLInputTypeAttribute, FormEvent, ChangeEvent, FocusEvent, createRef } from 'react'
import { BaseComponent, BaseProps, BaseState } from '../BaseComponent'

import { isEmpty } from '../../validation/stringRegex'

interface InputProps extends BaseProps {
    value: string | undefined,
    type?: HTMLInputTypeAttribute | undefined,
    regexp?: RegExp | Function | undefined,
    remoteValidation?: Function | undefined,
    min?: string | undefined
    error?: string | undefined
    bubleEvent?: boolean | undefined,
    forceFocus?: boolean | undefined
    ingoreLostFocus?: boolean | undefined

    refInput?: React.RefObject<HTMLInputElement> | undefined
}

interface InputState extends BaseState {
    hasFocus: boolean
}

/**
 * gli attributi sicuramente gestiti -- quelli da non riscrivere
 */
const defaults : InputProps = {
    value: undefined,
    id: undefined,
    className: 'form-control-lg',
    type:'text',
    onFocus: undefined,
    onBlur: undefined,
    onChange: undefined,
    callback: undefined,
    regexp: undefined,
    error: undefined,
    errorDisplayMsg: undefined,
    remoteValidation: undefined,
    bubleEvent: false,
    forceFocus: false,
    ingoreLostFocus: false,
    refInput: undefined,
}

class Input extends BaseComponent<InputProps, InputState> {
    private stepInput: React.RefObject<HTMLInputElement>

    constructor (props: any) {
        super(props)

        this.mergedProps = { ...defaults, ...props} as InputProps

        let value = (this.props.value)
        let errors = undefined

        if (this.notEmpty(value)) {
            errors = this.validate(value)
        }

        if (this.notEmpty(this.props.error)) {
            errors = this.props.error
        }

        this.state = {
            hasFocus: false,
            validationError: errors
        }

        this.printInput = this.printInput.bind(this)

        this.onFocuskHandler = this.onFocuskHandler.bind(this)
        this.onBlurHandler = this.onBlurHandler.bind(this)
        this.onChange = this.onChange.bind(this)

        this.validate = this.validate.bind(this)
        this.setError = this.setError.bind(this)

        this.setDomFocus = this.setDomFocus.bind(this)

        this.handlerCallBack = this.handlerCallBack.bind(this)

        this.stepInput = (this.props.refInput !== undefined) ? this.props.refInput : createRef()
    }

    componentDidMount(): void {
        if (
            this.props.forceFocus === true &&
            document.activeElement?.id !== this.stepInput.current?.id
        ) {
            this.stepInput.current?.focus()
        }
    }

    componentDidUpdate(prevProps: Readonly<InputProps>, prevState: Readonly<InputState>, snapshot?: any): void {
        // evito la perdita del focus quando rimuovo lo span di errore
        if (
            // se ho un valore
            (
                !isEmpty( this.props.value ) && isEmpty( prevProps.value )
            ) &&
            // se C'ERA un errore che ORA NON C'E
            (
                isEmpty( this.props.error ) && !isEmpty( prevProps.error )
            ) && 
            // ma ho perso il focus
            (
                isEmpty( document.activeElement?.id ) || document.activeElement?.id !== this.stepInput.current?.id
            )
        ) {
            // se prima avevo un errore e ora no --> lo span di errore non viene più disegnato
            // quindi il component fa un re - render --> quindi rido il focus
            this.setDomFocus()
        }
    }

    render () {
        const attributes = this.getPropertyDifferences (this.mergedProps ?? {}, defaults)

        const labelTag = this.getLabel()
        const errorTag = this.getTextError()

        const classString = 
            (this.notEmpty(this.props.value) && errorTag === undefined ? 'is-ok ' : '') +
            (this.state.hasFocus ? 'focus ' : '') +
            (
                (this.props.className ?? '') === 'form-control-lg' 
                    ? this.props.className + ' form-control-lg'
                    : 'form-control-lg' 
            ) + 
            (errorTag !== undefined ? ' is-invalid' : '')

        return (
            (this.props.id) &&
                <>
                    {labelTag !== undefined && labelTag}
                    {
                        errorTag !== undefined
                        ?   <div className='input-group'>
                                {this.printInput( classString, attributes )}

                                <span className="input-group-text">
                                    {errorTag}
                                </span>
                            </div>
                        :   this.printInput( classString, attributes )
                    }
                    
                </>
        )
    }

    private printInput (classString: string, attributes: any) {
        return (
            <input 
                id={this.props.id}
                className={classString}
                type={this.props.type}
                name={this.props.name}
                value={this.props.value || ''}
                
                // riporto gli eventi a cui sono intressato
                onFocus={this.onFocuskHandler}
                onBlur={this.onBlurHandler}
                onChange={this.onChange}

                // il referer
                ref={this.stepInput}

                // stampo tutte le altre props
                {...attributes}
            />
        )
    }

    private validate (val: any) {
        if (this.props.regexp !== undefined && val !== undefined) {

            if ( typeof this.props.regexp === 'object' ) {
                const pattern: any = new RegExp(this.props.regexp)
                if ( !pattern.test(val) ) {
                    return this.props.errorDisplayMsg ?? 'Valore non valido'
                }
            } else if ( typeof this.props.regexp === 'function' ) {
                if ( !this.props.regexp( val ) ) {
                    return this.props.errorDisplayMsg ?? 'Valore non valido'
                }
            }


        }
        return undefined
    }

    private onChange (e: ChangeEvent<HTMLInputElement>) {
        e.stopPropagation()

        /* FISSA il BUG RELATIVO ALLO SPOSTAMENTO DEL CURSORE  */
        const pointer = e.target.selectionStart
        const element = e.target
        if (
            this.props.type !== 'date' &&
            this.props.type !== 'email' &&
            this.props.type !== 'number' &&
            element
        ) {
            window.requestAnimationFrame( () => {
                element.selectionStart = pointer
                element.selectionEnd = pointer
            })
        }
        /* FISSA LO SPOSTAMENTO DEL CURSORE  */

        this.handlerCallBack(
            (this.props.bubleEvent === true)
                ? e
                : e.currentTarget.value
        )

        if (this.props.onChange) {
            this.props.onChange(e)
        }

        this.setDomFocus()
    }

    private onFocuskHandler (e: FocusEvent<HTMLInputElement>) {
        e.stopPropagation()

        // disabilito l'autocompletamento di chrome
        e.target.setAttribute( "autocomplete", this.props.id ?? '')

        this.setState(
            {
                hasFocus: true,
                validationError: undefined
            },
            () => {
                this.setDomFocus()

                if (this.props.onFocus) {
                    this.props.onFocus(e)
                }
            }
        )
    }

    private onBlurHandler (e: FocusEvent<HTMLInputElement>) {
        e.stopPropagation()

        const value = (e.currentTarget.value)
            ? e.currentTarget.value.trim()
            : undefined

        let errors = undefined

        this.handlerCallBack(value)

        if (this.notEmpty(value)) {
            errors = this.validate(value)

            if (errors === undefined && this.props.remoteValidation !== undefined) {
                this.props.remoteValidation(
                    value,
                    this.setError
                )
            }
        }

        this.setState(
            {
                hasFocus: false,
                validationError: errors
            },
            () => {
                if (this.props.onBlur) {
                    this.props.onBlur(e)
                }
                
            }
        )
    }

    private handlerCallBack (value: any) {
        if (this.props.callback) {
            this.props.callback (
                value
            )
        }
    }

    private setError (error: any) {
        this.setState({
            validationError: this.props.errorDisplayMsg ?? error
        })
    }

    private setDomFocus () {
        // se ho perso il focus & non si tratta della registrazione della password -- si scambiano il focus..
        // lo riprendo
        if (
            this.props.ingoreLostFocus !== true
        ) {
            this.stepInput.current?.focus()
        }
    }
    
}

export default Input